// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/ITeroCheckPatientConnection/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Images_Content_Content_Content_Content_ITeroCheckPatientConnection_Content(
  $patient_id: uuid!
  $location_id: uuid!
  $app_id: uuid
) {
  apps_pre_check_apps_connections(
    patient_id: $patient_id
    location_id: $location_id
    app_id: $app_id
  ) {
    id: app_id
    status
  }
}

`